import React from 'react';

/**
 * Applies try catch to react component
 * Works also on SSR.
 * @param {React.FC} Component – react component
 */
export const withTryCatch = (Component) => {
	return (props) => {
		// Cases like React.memo(), uncatchable.
		if (typeof Component !== 'function') {
			return <Component {...props} />;
		} else {
			try {
				return Component(props);
			} catch (e) {
				if (typeof e === 'object' && e !== null && typeof (e as Record<string, unknown>).then === 'function') {
					throw e;
				}

				console.error('Component error: exception, component, props.', e, Component, props);

				return null;
			}
		}
	};
};